module.exports = __webpack_public_path__ + "static/default-blog-image-fcc9c92d6b6a0f006763000a14be1da4.png";